
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/discount-codes",
      function () {
        return require("private-next-pages/my/discount-codes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/discount-codes"])
      });
    }
  